<template>
    <div class="card">
        <div class="network-picture" v-imagekit.background="{ image: network.picture, transform: 'h-77,w-77,fo-auto'}">
            <img class="sr-only" v-imagekit.src="{ image: network.picture, transform: 'h-77,w-77,fo-auto'}" :alt="network.name">
        </div>
        <div class="content">
            <h6>{{ network.name }} Network</h6>
            <p>
                <i class="icons8-user-account"></i>
                 <span>
                    {{ network.stats.membercount | formatNumber }}
                  </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'network-card',
    props: {
        network: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .card {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 100%;
        @include media-breakpoint-down(md) {
            padding: 25px 20px;
        }

        &:hover {
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.06);
        }
    }

    .network-picture {
        width: 77px;
        height: 77px;
        border-radius: 50%;
        background-color: $grey;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
        overflow: hidden;
        display: none;

        @include media-breakpoint-up(md) {
            display: block;
        }
    }

    h6 {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.5;
        @include media-breakpoint-up(md) {
            margin-bottom: 0;
        }
    }

    .content {
        @include media-breakpoint-up(md) {
            width: 62%;
            margin-left: 15px;
        }

        p {
            margin-bottom: 0;
            font-size: 16px;
            color: $grey;
            display: flex;
            align-items: center;
            align-content: center;
            flex-direction: row;
        }

        i {
            font-size: 20px;
            margin-right: 4px;
            vertical-align: middle;
            color: $grey-icon;
        }
    }
</style>
